module.exports = __webpack_public_path__ + "static/media/cover-fb-totul-pentru-educatie-v2.575696eb.jpg";